import Vue from 'vue';
import Vuemoment from 'vue-moment';
import moment from 'moment';
import 'moment/locale/it';

Vue.use(Vuemoment, {
    moment
});
